import * as React from 'react';
export const ToggleGroupContext = React.createContext({
    size: 'default',
    variant: 'default',
    spacing: 0,
});
//# sourceMappingURL=toggle-group-context.js.map